import icon from "../../assets/internet-security.svg";
import type { Property } from "../../types";

export const fipsCompliance: Property = {
  id: "fipsCompliance",
  title: "fipsCompliance.title",
  icon,
};
